import { SETTINGS_FETCH, SETTINGS_FAILED, SETTINGS_LOADING } from '../actions/settingsAction'

export const initialItemsState = { loading: true, data: [], paymentMethods: {}, error: null }

export const settingsReducer = (state = initialItemsState, action) => {
  switch (action.type) {
    case SETTINGS_LOADING:
      return { ...state, loading: true }
    case SETTINGS_FETCH:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        paymentMethods: action.payload.payment_methods || {}
      }
    case SETTINGS_FAILED:
      return { ...state, loading: false, data: [], paymentMethods: {}, error: action.payload }
    default:
      return state
  }
}
